import { motion } from "framer-motion";

/**
 * Decorative animated background: subtle moving grid + golden light rays
 * sweeping diagonally. Pure CSS/SVG, no JS work after mount.
 */
export function AmbientBg() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated grid */}
      <motion.div
        className="absolute inset-0 opacity-[0.06]"
        initial={{ backgroundPosition: "0px 0px" }}
        animate={{ backgroundPosition: "60px 60px" }}
        transition={{ duration: 14, repeat: Infinity, ease: "linear" }}
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(230,190,92,0.5) 1px, transparent 1px), linear-gradient(to bottom, rgba(230,190,92,0.5) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      {/* Light rays */}
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          className="absolute -top-1/2 left-0 w-[35%] h-[200%] origin-top"
          style={{
            background:
              "linear-gradient(180deg, rgba(230,190,92,0.18) 0%, rgba(230,190,92,0.05) 40%, transparent 80%)",
            filter: "blur(40px)",
            transform: `translateX(${i * 30}%) rotate(15deg)`,
          }}
          initial={{ opacity: 0.2, x: `${-30 + i * 25}%` }}
          animate={{ opacity: [0.15, 0.45, 0.15], x: [`${-30 + i * 25}%`, `${20 + i * 25}%`, `${-30 + i * 25}%`] }}
          transition={{ duration: 12 + i * 4, repeat: Infinity, ease: "easeInOut", delay: i * 2 }}
        />
      ))}

      {/* Spot glow */}
      <motion.div
        className="absolute top-1/3 right-1/4 w-[400px] h-[400px] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(230,190,92,0.18) 0%, transparent 70%)",
          filter: "blur(20px)",
        }}
        animate={{ scale: [1, 1.15, 1], opacity: [0.5, 0.85, 0.5] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
}
